import { Theme } from "@mui/material";

export const SettingsStyles = {
  SettingsContainer: {
    display: "flex",
    flexDirection: "column",
    paddingY: 3,
    gap: 3,
  },

  AccountSettingsHeading: {
    background: (theme: Theme) =>
      `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
  },

  SettingsCardActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "20%",
  },

  AvatarCard: {
    height: "100%",
  },

  AvatarCardContent: {
    height: "80%",
  },
};
